<template>
  <el-dialog title="常用游戏管理" :visible.sync="dialogVisible" width="780px" @open="initQueryAction">
    <div class="query-row">
      <el-form class="elementui-common-form-styles" inline>
        <el-form-item>
          <el-input v-model="queryForm.keyword" clearable placeholder="请输入应用名称或ID"></el-input>
        </el-form-item>

        <el-form-item>
          <el-select v-model="queryForm.platform" clearable @change="initQueryAction">
            <el-option v-for="platform in PLATFORM_LIST" :key="platform.value" :label="platform.label" :value="platform.value"></el-option>
          </el-select>
        </el-form-item>

        <el-button type="primary" :loading="tableLoading" @click="initQueryAction">查询</el-button>
      </el-form>

      <el-button type="primary" @click="showAddConfigModal()">新增常用游戏</el-button>
    </div>

    <ConfigTable v-loading="tableLoading" :data="tableData" height="320" border class="common-el-table-styles">
      <template #default="{ row }">
        <el-button type="text" @click="onTableRowRemove(row)">删除</el-button>
        <el-button type="text" @click="onTableRowUpdate(row)">编辑</el-button>
      </template>
    </ConfigTable>
    <div class="pager">
      <el-pagination
        background
        @current-change="getTableData"
        :page-size="pager.pageSize"
        :current-page.sync="pager.pageIndex"
        layout="prev, pager, next, total"
        :total="pager.total"
      >
      </el-pagination>
    </div>

    <AddConfigModal ref="addConfigRef" :title="isEdit ? '编辑常用游戏' : '新增常用游戏'" :visible.sync="showAddFormModal">
      <el-button @click="showAddFormModal = false">取消</el-button>
      <el-button type="primary" :loading="addConfigSubmitLoading" @click="onPopularGameConfigSubmit">确认</el-button>
    </AddConfigModal>

    <div slot="footer">
      <slot></slot>
    </div>
  </el-dialog>
</template>

<script setup>
import { ref, computed } from 'vue'
import ConfigTable from './config-table.vue'
import AddConfigModal from './add-config-modal.vue'

import { queryPopulargameByPage, addPopularGame, delPopularGame } from '@/api/track.plan.model'
import { PLATFORM_LIST, PLATFORM } from '../../consts/index.js'
import { useAddPoPularGameModal } from '../../hooks/useAddPoPularGameConfig.js'
import { MessageBox } from 'element-ui'
// eslint-disable-next-line
const props = defineProps({
  visible: {
    type: Boolean,
    default: false
  }
})
// eslint-disable-next-line
const emits = defineEmits(['update:visible'])
const dialogVisible = computed({
  get() {
    return props.visible
  },
  set(v) {
    emits('update:visible', v)
  }
})
const tableData = ref([])
const tableLoading = ref(false)
const queryForm = ref({
  keyword: '',
  platform: ''
})

const pager = ref({
  pageSize: 30,
  pageIndex: 1,
  total: 0
})

function initQueryAction() {
  pager.value.pageIndex = 1
  getTableData()
}
function getTableData() {
  tableLoading.value = true
  const { pageSize, pageIndex } = pager.value
  queryPopulargameByPage({ ...queryForm.value, pageSize, pageIndex })
    .then((res) => {
      const { datas, total } = res
      tableData.value = datas
      pager.value.total = total
    })
    .finally(() => {
      tableLoading.value = false
    })
}

function onTableRowUpdate(row) {
  showAddConfigModal(row)
}

function onTableRowRemove(row) {
  MessageBox.confirm('确定删除该记录吗？', '提示', {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    type: 'warning'
  }).then(() => {
    delPopularGame({ gameId: row.productId }).then((data) => {
      if (data) {
        getTableData()
      }
    })
  })
}

const { isEdit, showAddFormModal, addConfigSubmitLoading, addConfigRef, showAddConfigModal, onPopularGameConfigSubmit } =
  useAddPoPularGameModal(getTableData)
</script>

<style scoped lang="scss">
::v-deep .query-row {
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;

  .el-form {
    .el-form-item {
      margin-bottom: 0 !important;
    }
  }
}

.pager {
  margin-top: 6px;
  text-align: right;
}
</style>
